// The one place a stored player photo URL becomes something an <img> can load.
//
// football.co.il images are hot-link protected, so they route through the gateway image proxy
// (Zero.Players `/health/image-proxy`). A photo an admin UPLOADED is stored as a gateway path,
// `/api/player-photos/{id}` (Zero.Players `PlayerPhotoStore.UrlPrefix`), and is re-based onto
// the configured API origin here, for a deployment where that is not this page's own `/api`.
// Other hosts (e.g. TheSportsDB) render directly.

// Runtime config (Railway) takes priority; falls back to the Vite proxy (/api)
// for local dev — same resolution as lib/api.ts.
const cfg = (window as unknown as { __CONFIG__?: { API_BASE_URL?: string } }).__CONFIG__ ?? {};
const API_BASE = cfg.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '/api';

export function proxiedImageUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  if (url.includes('football.co.il')) {
    return `${API_BASE}/image-proxy?url=${encodeURIComponent(url)}`;
  }
  if (url.startsWith('/api/')) {
    return `${API_BASE}${url.slice('/api'.length)}`;
  }
  return url;
}
